import { connect } from 'react-redux'
import { IConnectParams } from 'components/Logs/types'
import { Logs as LogsComponent } from 'components/Logs'

interface IStore {
  userProfile: {
    userProfileDetails: {
      id: number
    }
  }
}

const Logs = connect<IConnectParams, {}, {}, IStore>(({ userProfile: { userProfileDetails } }) => ({
  objId: userProfileDetails.id,
  objType: 'ParentUser',
}))(LogsComponent)

export default Logs
